import React from 'react';

import svgSprite from '@syskit/sico/symbol-defs.svg';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import SvgSpriteRenderer from "../../../components/svgSpriteRenderer/svgSpriteRenderer";


import HomePage from '../pages/homePage/homePage';

const App = () => {
    if (!navigator.cookieEnabled) {
        return (
            <div className="cookies-disabled">
                <h1>We can't sign you in</h1>
                <p>Your browser is currently set to block cookies.<b>You need to allow cookies to use this service.</b></p>
                <p>Cookies are small text files stored on your computer that tell us when you're signed in. To learn how to allow cookies, check the online help in your web browser.</p>
            </div>
        );
    }

    return (
        <>
            <SvgSpriteRenderer svgContent={svgSprite} />
            <BrowserRouter>
                <Switch>
                    <Route path={'/'} exact component={HomePage} />
                </Switch>
            </BrowserRouter></>
    )
}

export default App;